// deps
import { useContext } from "react";

// contexts
import { SearchContext } from ".";

/**
 * @template T
 * @template [TFormValues = any]
 * @typedef {import("./Context").SearchContext<T, TFormValues>} UseSearch
 */

export default function useSearch() {
  return useContext(SearchContext);
}
